// extracted by mini-css-extract-plugin
module.exports = {"text":"logotype_text__1e3jY","logotype":"logotype_logotype__vh6_B","subText":"logotype_subText__FfWUT","capa":"logotype_capa__z3_Z8"};